<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 sm10 md8 offset-sm1 offset-md2>
        <v-layout wrap align-stretch v-if="$auth.check('EXPERT')">
          <v-flex xs12 sm6 class="d-flex">
            <main-page-button :title="$t('main.USER_MANAGE_HEAD')" :subtitle="$t('main.USER_MANAGE_DESC')" icon="group"
              route="Users">
            </main-page-button>
          </v-flex>

          <v-flex xs12 sm6 class="d-flex">
            <main-page-button :title="$t('main.SCHOOL_MANAGE_HEAD')" :subtitle="$t('main.SCHOOL_MANAGE_DESC')"
              icon="school" route="Schools">
            </main-page-button>
          </v-flex>

          <v-flex xs12 sm6 md4 class="d-flex">
            <main-page-button :title="$t('main.CHARTS_HEAD')" :subtitle="$t('main.CHARTS_DESC')" icon="timeline"
              route="Charts">
            </main-page-button>
          </v-flex>

          <v-flex xs12 sm6 md4 class="d-flex">
            <main-page-button :title="$t('main.ITEM_ANSWERS_HEAD')" :subtitle="$t('main.ITEM_ANSWERS_DESC')"
              icon="donut_small" route="Statistics">
            </main-page-button>
          </v-flex>

          <v-flex xs12 sm6 md4 class="d-flex">
            <main-page-button :title="$t('main.ITEM_EVOLUTION_HEAD')" :subtitle="$t('main.ITEM_EVOLUTION_DESC')"
              icon="insert_chart" route="ItemStatistics">
            </main-page-button>
          </v-flex>

          <v-flex xs12 sm6 class="d-flex">
            <main-page-button :title="$t('main.VALIDATOR_HEAD')" :subtitle="$t('main.VALIDATOR_DESC')" icon="pageview"
              route="QuestionnaireValidator">
            </main-page-button>
          </v-flex>

          <v-flex class="d-flex" xs12 sm6>
            <main-page-button :title="$t('main.GRID_HEAD')" :subtitle="$t('main.GRID_DESC')" icon="view_module"
              route="Grid">
            </main-page-button>
          </v-flex>

          <v-flex class="d-flex" xs12 sm6 md4>
            <main-page-button :title="$t('main.QUESTIONNAIRE_RESP_HEAD')" :subtitle="$t('main.QUESTIONNAIRE_RESP_DESC')"
              icon="question_answer" route="Questionnaires">
            </main-page-button>
          </v-flex>

          <v-flex class="d-flex" xs12 sm6 md4>
            <main-page-button :title="$t('main.RESULTS_HEAD')" :subtitle="$t('main.RESULTS_DESC')" icon="folder"
              route="Results">
            </main-page-button>
          </v-flex>

          <v-flex class="d-flex" xs12 sm6 md4>
            <div @click.stop="showTutorial = false" style="cursor: pointer;">
              <main-page-button :title="$t('main.TUTORIAL_HEAD')" :subtitle="$t('main.TUTORIAL_DESC')"
                icon="contact_support" :route="null">
              </main-page-button>
            </div>
          </v-flex>


          <v-flex class="d-flex" xs12 sm6 md4>
            <main-page-button :title="$t('main.EXPORT_EXCEL')" :subtitle="$t('main.EXPORT_EXCEL_DESC')"
              icon="file_download" :loading="loading" @exportExcel="exportExcel">
            </main-page-button>
          </v-flex>
        </v-layout>

        <v-layout wrap v-else>
          <v-flex class="d-flex" xs12 sm6>
            <main-page-button :title="$t('main.QUESTIONNAIRE_RESP_HEAD')" :subtitle="$t('main.QUESTIONNAIRE_RESP_DESC')"
              icon="question_answer" route="Questionnaires">
            </main-page-button>
          </v-flex>

          <v-flex class="d-flex" xs12 sm6>
            <main-page-button :title="$t('main.RESULTS_HEAD')" :subtitle="$t('main.RESULTS_DESC')" icon="folder"
              route="Results">
            </main-page-button>
          </v-flex>

          <v-flex class="d-flex" xs12 sm6>
            <main-page-button :title="$t('main.GRID_HEAD')" :subtitle="$t('main.GRID_DESC')" icon="view_module"
              route="Grid">
            </main-page-button>
          </v-flex>

          <v-flex class="d-flex" xs12 sm6>
            <div @click.stop="showTutorial = false" style="cursor: pointer;">
              <main-page-button :title="$t('main.TUTORIAL_HEAD')" :subtitle="$t('main.TUTORIAL_DESC')"
                icon="contact_support" :route="null">
              </main-page-button>
            </div>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout column v-show="!$auth.check('EXPERT') && recommendations.length > 0" justify-center align-center
      style="margin-top: 1em">
      <h3>{{ $t('main.CHOSEN_ITEMS') }}</h3>
      <v-layout row wrap child-flex>
        <v-flex xs12>
          <v-layout pa-1 row wrap>
            <v-flex v-for="(item, n) in recommendations" :key="n" xs12 md4>
              <evaloe-item-card :short="true" :item="findItemById(items, item.itemId)" :version="$auth.user().version"
                style="display: flex; flex-direction: column; height: 100%">
              </evaloe-item-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>

    <!-- Dialog para el tutorial con video -->
    <v-dialog v-model="showTutorial" max-width="600px" persistent>
      <!-- Solo renderizamos TutorialVideo si showTutorial es true -->
      <tutorial-video
        v-if="showTutorial"
        @close="showTutorial = false">
      </tutorial-video>
    </v-dialog>
  </v-container>
</template>

<script>
import { PopupResource } from '../api/popup'
import { RecommendationResource } from '../api/recommendation'
import { ItemResource } from '../api/item'
import EvaloeAssist from '@/components/questionnaires/EvaloeAssist'
import EvaloeItemCard from '@/components/questionnaires/EvaloeItemCard'
import { ExportResource } from '../api/export'
import MainPageButton from './common/MainPageButton'
import TutorialVideo from '@/components/tutorial/TutorialVideo.vue'

export default {
  name: 'main',
  components: {
    MainPageButton,
    EvaloeItemCard,
    'evaloe-assist': EvaloeAssist,
    TutorialVideo
  },
  data () {
    return {
      popups: [],
      getPopups: false,
      dialogWhatIs: false,
      loadingWhatIs: false,
      checkedWhatIs: false,
      dialogPurpose: false,
      loadingPurpose: false,
      checkedPurpose: false,
      dialogFeatures: false,
      loadingFeatures: false,
      checkedFeatures: false,
      showTutorial: false,
      version: this.$auth.user().version,
      items: [],
      recommendations: [],
      dialogKey: 30,
      dialogHelp: false,
      loading: false,
      error: null
    }
  },
  beforeRouteEnter (to, from, next) {
    const getPopups = from.name === 'Login'
    next(vm => {
      vm.getPopups = getPopups
    })
  },
  watch: {
    getPopups (val) {
      if (val === true) {
        PopupResource().get().then(response => {
          this.popups = response.body
          for (const popup of this.popups) {
            switch (popup.name) {
              case 'WHATIS':
                this.dialogWhatIs = true
                break
              case 'PURPOSE':
                this.dialogPurpose = true
                break
              case 'FEATURES':
                this.dialogFeatures = true
                break
            }
          }
        }).catch(error => {
          console.error(error)
        })
      }
    }
  },
  created () {
    ItemResource().get().then(response => {
      this.items = response.body
    }).catch(error => {
      console.error(error)
    })
  },
  mounted () {
    if (this.$auth.check('TEACHER')) {
      RecommendationResource().get().then(response => {
        const local = response.body
        for (const rec of local) {
          if (rec.chosen) this.recommendations.push(rec)
        }
      }).catch(error => {
        console.error('error', error.body)
      })
    }
    this.$auth.fetch()
    this.version = this.$auth.user().version
  },
  methods: {
    showHelp (itemId) {
      this.dialogKey = itemId
      this.dialogHelp = true
    },
    closeWhatIs () {
      this.loadingWhatIs = true
      const popup = this.findItemByName(this.popups, 'WHATIS')
      PopupResource().remove({ id: popup.id }).then(() => {
        this.loadingWhatIs = false
        this.checkedWhatIs = true
      }).catch(() => {
        this.loadingWhatIs = false
      })
    },
    closePurpose () {
      this.loadingPurpose = true
      const popup = this.findItemByName(this.popups, 'PURPOSE')
      PopupResource().remove({ id: popup.id }).then(() => {
        this.loadingPurpose = false
        this.checkedPurpose = true
      }).catch(() => {
        this.loadingPurpose = false
      })
    },
    closeFeatures () {
      this.loadingFeatures = true
      const popup = this.findItemByName(this.popups, 'FEATURES')
      PopupResource().remove({ id: popup.id }).then(() => {
        this.loadingFeatures = false
        this.checkedFeatures = true
      }).catch(() => {
        this.loadingFeatures = false
      })
    },
    closeDialogWhatIs () {
      this.dialogWhatIs = false
    },
    closeDialogPurpose () {
      this.dialogPurpose = false
    },
    closeDialogFeatures () {
      this.dialogFeatures = false
    },
    findItemByName (collection, itemName) {
      return this._.find(collection, i => i.name === itemName)
    },
    findItemById (collection, id) {
      return this._.find(collection, i => i.id === id)
    },
    exportExcel () {
      this.loading = true
      this.error = null
      ExportResource().exportExcel().then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        const today = new Date()
        const dd = String(today.getDate()).padStart(2, '0')
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const yyyy = today.getFullYear()
        const formattedDate = `${yyyy}-${mm}-${dd}`
        link.href = url
        link.setAttribute('download', `Estadistiques_EvaloeSSDUni_${formattedDate}.xlsx`)
        document.body.appendChild(link)
        link.click()
        this.loading = false
      }).catch((error) => {
        this.error = 'Error al exportar el archivo Excel. Inténtelo de nuevo.'
        console.error('Error al exportar el archivo Excel:', error)
        this.loading = false
      })
    }
  }
}
</script>

<style>
button .btn__content {
  white-space: inherit;
  flex: inherit;
}

.full-height .flex {
  display: flex;
}

.full-height .flex>.card {
  flex: 1 1 auto;
}
.d-flex {
  display: flex;
}

.flex-grow-1 {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue